<template>
  <div id="intercom-container" />
</template>
    
<script>
export default {
  name: 'Intercom',
  mounted () {
  
    window.intercomSettings = {
      alignment: 'right',
      app_id: 'kuj97peb',
      user_hash: this.$ftUser.intercomHashId,
      user_id: `${this.$ftUser.club}_${this.$ftUser.username}`,
      email: `${this.$ftUser.club}@foretees.com`,
      name: `${this.$ftUser.club}_${this.$ftUser.username}`,
      activity_id: 9999,
      page: 'dining',
      clubname: this.$ftUser.club,
      created_at: Math.floor(Date.now() / 1000),
      custom_launcher_selector: '#open_intercom',
      hide_default_launcher: true,
    }
  
    this.loadIntercomScript().then(() => {
      this.initializeIntercom()
    }).catch((error) => {
      console.error('Intercom script failed to load:', error)
    })
  
    const switchToNewsTab = () => {
      let attempts = 0
      const maxAttempts = 400
      const interval = setInterval(() => {
        const iframe = document.querySelector(
          'iframe[name^="intercom-messenger-frame"]'
        )
        if (iframe) {
          const iframeDoc =
              iframe.contentDocument || iframe.contentWindow.document
          const newsTabButton = iframeDoc.querySelector(
            'button[data-testid="news"]'
          )
          if (newsTabButton) {
            newsTabButton.click()
            clearInterval(interval)
          }
        }
        attempts++
        if (attempts >= maxAttempts) {
          clearInterval(interval)
        }
      }, 5)
    }
  
    const bootIntercom = () => {
      window.Intercom('boot', window.intercomSettings)
      window.Intercom('onShow', switchToNewsTab)
    }
  
    const checkIntercomLoaded = setInterval(() => {
      if (window.Intercom) {
        clearInterval(checkIntercomLoaded)
        bootIntercom()
      }
    }, 5)
  },
  methods: {
    loadIntercomScript () {
      return new Promise((resolve, reject) => {
        if (window.Intercom) {
          resolve()
          return
        }
        const script = document.createElement('script')
        script.src = 'https://widget.intercom.io/widget/kuj97peb'
        script.async = true
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },
  
    initializeIntercom () {
      window.Intercom('boot', window.intercomSettings)
    },
  },
}
</script>